import { compose } from 'recompose';
import { connect } from 'react-redux';

import { isAuthenticated } from '../../../store/session/selectors';

export const enhance = compose(
  connect((state) => ({
    isLoggedIn: isAuthenticated(state),
  }))
);
